export default __webpack_public_path__ + "static/media/cart3.53c03428.jpg";